.VolumeControl {
  max-width: 100px;
}
